import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import {FilterCard} from '../../../../atoms/FilterCard/FilterCard';
import {SizeRun} from '../../FilterContent/Size/SizeRun';
import {SizeType} from '../../FilterContent/Size/types';
import {FilterFlyout} from '../FilterFlyout';
import {FilterFlyoutFooter} from '../FilterFlyoutFooter';

interface Props {
  activeSizeIds: Array<string>;
  label: string;
  onSizeClick: (sizeId: string) => void;
  sizes: Array<SizeType>;
  enableFlyoutFilter: boolean;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
}

export const FilterFlyoutSizeSimple: FC<Props> = ({
  activeSizeIds,
  label,
  onSizeClick,
  sizes,
  enableFlyoutFilter,
  hide,
  isOpen,
  open,
  submit,
}) => {
  const {t} = useTranslation();

  const handleOnHide = () => {
    hide();
  };

  return (
    <div data-testid="filterFlyoutSectionSizeSimple">
      <FilterCard
        onClick={open}
        count={activeSizeIds.length ?? undefined}
        title={label}
        disableHorizontalPadding={enableFlyoutFilter}
      />
      <FilterFlyout
        data-testid="filterFlyoutSectionSizeGrouped_filterFlyout"
        onClose={handleOnHide}
        open={isOpen}
        title={t('Size')}
        primaryButtonLabel={t('Submit')}
        onPrimaryButtonClick={submit}
        secondaryButtonLabel={t('Back')}
        footer={FilterFlyoutFooter}
      >
        <SizeRun
          activeSizeIds={activeSizeIds}
          onSizeClick={(sizeId: string) => onSizeClick(sizeId)}
          sizes={sizes}
        />
      </FilterFlyout>
    </div>
  );
};
